import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, map, Observable } from 'rxjs';

export enum AbandonCartDataKeys {
  WORKFLOW = 'Workflow',
  SSO_EMAIL_ADDRESS = 'SSO Email Address',
  NAME = 'Full Name',
  MEMBERSHIP = 'Membership',
  QUANTITY = 'Quantity',
  PRODUCT_NAME = 'Product Name',
  PRODUCT_ITEM_NUMBER = 'Product Item Number',
  SERVICE_PERIOD_CODE = 'Service Period Code',
  BILLING_EMAIL = 'Billing Email Address',
  ORDER_NUMBER = 'Order Number',

  BILLING_FIRST_NAME = 'Billing First Name',
  BILLING_LAST_NAME = 'Billing Last Name',
  BILLING_COMPANY_NAME = 'Billing Company Name',
  BILLING_ADDRESS_LINE1 = 'Billing Address Line1',
  BILLING_ADDRESS_LINE2 = 'Billing Address Line2',
  BILLING_ADDRESS_CITY = 'Billing Address City',
  BILLING_ADDRESS_STATE = 'Billing Address State',
  BILLING_ZIP_CODE = 'Billing Zip Code',
  BILLING_PHONE = 'Billing Phone',
 
}

export enum AbandonBackendEvents {
  FIRST_EMAIL_SENT = 'First reminder email sent',
  SECOND_EMAIL_SENT = 'Second reminder email sent',
  THIRD_EMAIL_SENT = 'Third reminder email sent'
}

export enum AbandonCartEvents {
  SHOPING_CART_STARTED = 'Shoping Cart Started',
  ORDER_REVIEW_STARTED = 'Order Review Started',
  ORDER_SUBMITTED = 'Order Submitted',
}
export interface FlowParams {
  customerNbr?: string;
  ssoId?: string;
  membership?: string;
  orderNumber?: string;
  data?: KeyValue[];
  events?: TrackingEvent[];
}
export interface FlowTracking extends FlowParams {
  flowId: string;
}
export interface KeyValue {
  dataKey: string;
  dataValue: string;
}

export interface TrackingEvent {
  trackingEvent: string;
  updateEventDtm?: Date;
}

export interface FlowResponse {
  Data: FlowData;
  Errors: any[];
  ErrorMessage: string | null;
}

export interface FlowData {
  trackingId: number;
  flowId: string;
  customerNbr: string;
  ssoId: string;
  events: TrackingEvent[];
  data: KeyValue[];
}

@Injectable({
  providedIn: 'root'
})
export class TrackingService {
  flowFetchingNow: boolean = false;
  sessionTrackingId:string = '';
  cachedEndpointResponse: {} = {};
  constructor(
       private httpClient: HttpClient,
  ) { }

  async upsertFlow(flow: FlowParams): Promise<void> {
    if (flow.data) {
      flow.data = this.sanitizeDataValues(flow.data);
    }
    const flowId = this.sessionTrackingId;
    if (flowId) {
         return await firstValueFrom(
             this.updateFlow({
                  ...flow,
                  flowId: flowId
            })
        );
    } else {
          this.upsertWithCustomerNumber(flow)
            .then((response) => {
                this.setSessionTrackingId(response.data.flowId);
          })
            .catch((error) => {
          });
    } 
    
  }

  async upsertEvent(flow: FlowParams): Promise<void> {
    
    const flowId = this.sessionTrackingId;
    if (flowId) {
         return await firstValueFrom(
             this.updateFlow({
                  ...flow,
                  flowId: flowId
            })
        );
    } else {
          this.upsertWithCustomerNumberOrderNumber(flow)
            .then((response) => {
                this.setSessionTrackingId(response.data.flowId);
          })
            .catch((error) => {
          });
    } 
    
  }

   private findFlowByCustomerNbr(customerNbr: string, ssoId: string
  ): Observable<FlowTracking> {
   
    return this.httpClient.get('/ocmapi/tracking/recent', {
      params: {
        customerNbr: customerNbr,
        ssoId: ssoId
      }
    }).pipe(map((response: any) => {
      const parsed = typeof response === 'string' ? JSON.parse(response) : response;
      this.sessionTrackingId = parsed.Data.flowId;
      return parsed.Data;
    }));
  }
  
  findFlowByCustomerNbrAndOrder(customerNbr: string, orderNumber: string
  ): Observable<FlowTracking> {
   
    return this.httpClient.get('/ocmapi/tracking/recentByCustNbrAndOrder', {
      params: {
        customerNbr: customerNbr,
        orderNumber: orderNumber
      }
    }).pipe(map((response: any) => {
      const parsed = typeof response === 'string' ? JSON.parse(response) : response;
      this.sessionTrackingId = parsed.Data.flowId;
      return parsed.Data;
    }));
  }

  getFlowById(flowId: string): Observable<any> {
    return this.httpClient.get('/ocmapi/tracking/flow', {
      params: {
        flowId: flowId
      }
    });
  }


  setSessionTrackingId(flowId: string): void {
    this.sessionTrackingId = flowId;
  }
  private sanitizeDataValues(data: KeyValue[]): KeyValue[] {
    const sanitizedData: KeyValue[] = [];

    for (const entry of data) {
      const sanitizedDataValue = entry.dataValue ? entry.dataValue : '';
      sanitizedData.push({ ...entry, dataValue: sanitizedDataValue.toString() });
    }
    return sanitizedData;
  }

  private updateFlow(flow: FlowTracking): Observable<any> {
    return this.httpClient.post('/ocmapi/tracking/update', flow);
  }

  private async upsertWithCustomerNumber(flow: FlowParams): Promise<any> {
    try {
      const response: FlowTracking | undefined = await firstValueFrom(
        this.findFlowByCustomerNbr(flow.customerNbr!, flow.ssoId!)
      );

      if (!response) {
        console.log('Customer response not found');
        // optionally create new flow here:
        // return await firstValueFrom(this.createFlow(flow));
        return;
      }

      return await firstValueFrom(
        this.updateFlow({
          ...flow,
          flowId: response.flowId
        })
      );

    } catch (error) {
      console.error('Error in upsertWithCustomerNumber:', error);
      throw error;
    }
  }

private async upsertWithCustomerNumberOrderNumber(flow: FlowParams): Promise<any> {
    try {
      const response: FlowTracking | undefined = await firstValueFrom(
        this.findFlowByCustomerNbrAndOrder(flow.customerNbr!, flow.orderNumber!)
      );

      if (!response) {
        console.log('Customer response not found');
        // optionally create new flow here:
        // return await firstValueFrom(this.createFlow(flow));
        return;
      }

      console.log('FOUND FLOW by customer number and orderNumber');
      console.log(`response flowId ${JSON.stringify(response.flowId)}`);

      return await firstValueFrom(
        this.updateFlow({
          ...flow,
          flowId: response.flowId
        })
      );

    } catch (error) {
      console.error('Error in upsertWithCustomerNumberOrderNumber:', error);
      throw error;
    }
  }
}


